/* eslint-disable */

export enum BankTransactionStatus {
  PAID = 3,
  FAILED = 4
}

export const BankTransactionStatusTypeString: any = {
  [BankTransactionStatus.PAID]: "label-title.paid",
  [BankTransactionStatus.FAILED]: "label-title.failed"
};

/* eslint-disable */
export enum CreditStatus {
  ADDED = 1,
  DEDUCTED = 2
}

export const CreditStatusString: any = {
  [CreditStatus.ADDED]: "label-title.added",
  [CreditStatus.DEDUCTED]: "label-title.deducted"
};

export enum RefundReason {
  BOOKING_REMAINING_AMOUNT = "BOOKING_REMAINING_AMOUNT"
}

export const RefundReasonString: any = {
  [RefundReason.BOOKING_REMAINING_AMOUNT]: "label-title.booking-remaining-amount"
};

export enum PenaltyType {
  RIDE_CANCELLATION = "RIDE_CANCELLATION",
  LOW_RATING = "LOW_RATING",
  MISSED_RIDES = "MISSED_RIDES",
  LATE_ARRIVAL = "LATE_ARRIVAL"
}

export const PenaltyTypeString: any = {
  [PenaltyType.RIDE_CANCELLATION]: "label-title.ride-cancellation-penalty",
  [PenaltyType.LOW_RATING]: "label-title.low-rating-penalty",
  [PenaltyType.MISSED_RIDES]: "label-title.rides-missed-penalty",
  [PenaltyType.LATE_ARRIVAL]: "label-title.late-arrival-penalty"
};

export enum CreditTransactionType {
  REFERRAL_BONUS = 1,
  REFERRER_BONUS = 2,
  DIGITAL_PAYMENT = 3,
  FROM_ADMIN = 4,
  TIP_PAYMENT = 5,
  TO_FRIEND = 6,
  FROM_FRIEND = 7,
  REWARD_POINT_WITHDRAW = 8,
  PENALTY = 9,
  BOOKING_PAYMENT = 10,
  CANCEL_BOOKING_PAYMENT = 11,
  BOOKING_PROFIT = 12,
  INCENTIVE = 13,
  BANK_TRANSFER = 14,
  REFUND = 15,
  SUBSCRIPTION = 16,
  PLATFORM_FEE = 17,
  FIXED_GROUP_RIDE_PAYMENT = 18
}

export const CreditTransactionTypeString: any = {
  [CreditTransactionType.REFERRAL_BONUS]: "label-title.referral-id",
  [CreditTransactionType.REFERRER_BONUS]: "label-title.referrer-code",
  [CreditTransactionType.DIGITAL_PAYMENT]: "label-title.payment-gateway",
  [CreditTransactionType.FROM_ADMIN]: "label-title.admin",
  [CreditTransactionType.TIP_PAYMENT]: "label-title.tip",
  [CreditTransactionType.TO_FRIEND]: "label-title.sent-to-friend",
  [CreditTransactionType.FROM_FRIEND]: "label-title.recieved-from-friend",
  [CreditTransactionType.REWARD_POINT_WITHDRAW]: "label-title.redeem-reward-points",
  [CreditTransactionType.PENALTY]: "label-title.penalty",
  [CreditTransactionType.BOOKING_PROFIT]: "label-title.booking-profit-of-this-trip",
  [CreditTransactionType.BOOKING_PAYMENT]: "label-title.booking-payment-of-this-trip",
  [CreditTransactionType.CANCEL_BOOKING_PAYMENT]: "label-title.cancel-booking-payment-of-this-trip",
  [CreditTransactionType.INCENTIVE]: "label-title.incentive-of-this-trip",
  [CreditTransactionType.BANK_TRANSFER]: "label-title.bank-transfer",
  [CreditTransactionType.SUBSCRIPTION]: "label-title.subscription",
  [CreditTransactionType.PLATFORM_FEE]: "label-title.platform-fee",
  [CreditTransactionType.FIXED_GROUP_RIDE_PAYMENT]: "label-title.fixed-group-ride-payment"
};
